import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  loadLessonDetail,
  deleteLesson,
  clearLessonDetail,
  addFavoriteLesson,
} from '../../common/lessons/actions'
import { roles, exerciseTypes } from '../../common/config'
import PageHeader from '../components/PageHeader'
import Pexeso from '../components/Pexeso'


class PexesoPage extends React.Component {
  componentDidMount() {
    const { loadLessonDetail, match } = this.props
    if (match && match.params.id) {
      loadLessonDetail(match.params.id)
    }
  }

  componentDidCatch(error, info) {
    console.log('error - PexesoPage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentWillUnmount() {
    this.props.clearLessonDetail()
  }

  render() {
    const { currentLesson, intl } = this.props

    if (!currentLesson || currentLesson.type !== exerciseTypes.TRANSLATION) {
      return null
    }

    return (
      <div className="page flex-column">
        <PageHeader
          title={`${intl.formatMessage(messages.title)}: ${currentLesson.name}`}
        />
        <Pexeso lesson={currentLesson} />
      </div>
    )
  }
}

PexesoPage.defaultProps = {
  currentLesson: null,
  match: null,
  viewer: null,
}

PexesoPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadLessonDetail: PropTypes.func.isRequired,
  deleteLesson: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  addFavoriteLesson: PropTypes.func.isRequired,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  viewer: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
  }), { loadLessonDetail, deleteLesson, clearLessonDetail, addFavoriteLesson }),
  injectIntl,
)

export default enhance(PexesoPage)

const messages = defineMessages({
  title: {
    id: 'pexeso.page',
    defaultMessage: 'Pexeso',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/PexesoPage.js